import React from "react";
import { Button, GridItem } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Form, Grid, ImageUploader, TextInput } from "components";
import { types } from "../../duck";
import { hooks, utils } from "./duck";

interface EditProps {
  initialValues: types.FormValues;
  onCancel: () => void;
}

const Edit: React.FC<EditProps> = ({ initialValues, onCancel }) => {
  const update = hooks.useUpdateOrganization(onCancel);

  return (
    <Form {...utils.getValidation(initialValues)} onSubmit={update}>
      <Grid>
        <GridItem>
          <TextInput name="name" label="Name" placeholder="Name" />
        </GridItem>
        <GridItem>
          <TextInput
            name="description"
            label="Description"
            placeholder="Description"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="contactEmail"
            label="Contact Email"
            placeholder="Contact Email"
          />
        </GridItem>
        <GridItem colStart={1}>
          <ImageUploader
            name="logo"
            label="Logo"
            allowedTypes={["svg"]}
            imageProps={{ objectFit: "contain" }}
          />
        </GridItem>
      </Grid>

      <Form.Controls mt={6} submitText="Save">
        <Button
          variant="outline"
          colorScheme="gray"
          as={Link}
          to="/organization-management"
        >
          Cancel
        </Button>
      </Form.Controls>
    </Form>
  );
};

export default Edit;
